export default "__VITE_ASSET__D_f5hrL0__"